import React, { useState , useRef , useEffect } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

// import JS files
import Header from "../shares/others/Header";

// import others files
import sample from "../../assets/imgs/media-sample1.png";
import useFetch from "../../context/useFetch";
import moment from "jalali-moment";
import { useNavigate } from "react-router-dom";

const Chief = (props) => {
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const getCompaniesListApi = useFetch({
    method: "get",
    url: "News_Service/get_last_chief_news",
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsList(res);
    },
  });

  const handleShow = (dir) => {
    if (dir == "next") {
      if (currentIndex == newsList.length - 1) {
        setCurrentIndex(0);
      } else {
        setCurrentIndex((before) => before + 1);
      }
    } else {
      if (currentIndex == 0) {
        setCurrentIndex(newsList.length - 1);
      } else {
        setCurrentIndex((before) => before - 1);
      }
    }
  };

  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === newsList.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => {
      resetTimeout();
    };
  }, [currentIndex]);

  return (
    <>
      {newsList.length > 0 && (
        <div className="mt-8 md:mt-16">
          <Header header="انتخاب سردبیر" noAllItems />
          <div className=" bg-mygrays-100 p-4 rounded-lg relative flex justify-center">
            <div className="w-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div
                onClick={() =>
                  setCurrentIndex((prevIndex) =>
                    prevIndex === newsList.length - 1 ? 0 : prevIndex + 1
                  )
                }
                className="bg-white p-1 rounded-lg transition-all hover:scale-110  cursor-pointer absolute top-1/2 left-2 md:left-5 transform  -translate-y-1/2"
              >
                <ArrowBackIosNewIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
              </div>
              <div
                onClick={() =>
                  setCurrentIndex((prevIndex) =>
                    prevIndex === 0 ? newsList.length - 1 : prevIndex - 1
                  )
                }
                className="bg-white p-1 rounded-lg transition-all hover:scale-110  cursor-pointer absolute top-1/2 right-2 md:right-5 transform  -translate-y-1/2"
              >
                <ArrowForwardIosIcon className="text-myblacks-100 transition-all hover:text-myblacks-400" />
              </div>
            </div>
            <div
              className="cursor-pointer w-11/12 grid md:grid-cols-12 md:gap-4"
              onClick={() =>
                navigate(`/news-content/${newsList[currentIndex].id}`)
              }
            >
              <div className="md:col-span-4 flex justify-center">
                <img
                  src={newsList[currentIndex].news_detail[0].cover}
                  className="w-full rounded-lg"
                />
              </div>
              <div className=" md:col-span-8 flex justify-between items-center">
                <div className=" w-full flex flex-col p-4">
                  <span className="font-bold text-myblacks-200 text-sm md:text-base text-justify">
                    {newsList[currentIndex].news_detail[0].sub_header}
                  </span>
                  <span className="font-bold text-myblacks-400 text-base md:text-lg text-justify mt-2">
                    {newsList[currentIndex].news_detail[0].header}
                  </span>
                  <div className="text-justify mt-4  leading-7 md:leading-8">
                    <span className=" text-myblacks-300   text-sm md:text-base">
                      {
                        newsList[currentIndex].news_detail[0]
                          .homepage_description_for_chief
                      }
                    </span>
                  </div>
                  <div className="flex justify-end text-xs text-myblacks-100 mt-4 md:mt-8">
                    <div className="flex items-center ">
                      <CalendarMonthIcon sx={{ fontSize: "1rem" }} />
                      <span className="mr-1">
                        {" "}
                        {moment(
                          newsList[currentIndex].news_detail[0].publish_at,
                          "YYYY/MM/DD"
                        )
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Chief;
